export function isInternalBugReporter(email = '') {
  return String(email).includes('katapultengineering');
}

export function getDefaultReporterName({ userDisplayName = '' } = {}) {
  return userDisplayName || '';
}

export function validateBugScreenshotFile(file) {
  if (!file) return { valid: true };

  const allowedMimeTypes = new Set(['image/png', 'image/jpeg', 'image/heic', 'image/heif', 'image/webp']);
  const allowedExtensions = /\.(png|jpe?g|heic|heif|webp)$/i;
  // Prefer MIME checks when available. Fall back to extension checks for browsers that omit MIME.
  const hasAllowedMimeType = Boolean(file.type) && allowedMimeTypes.has(file.type);
  const hasAllowedExtension = allowedExtensions.test(file.name || '');
  const valid = hasAllowedMimeType || (!file.type && hasAllowedExtension);

  return {
    valid,
    message: valid ? '' : 'Invalid file type. Please upload an image file.'
  };
}

export async function uploadBugScreenshots({ files = [], firebase, FirebaseWorker }) {
  const uploaded = [];
  for (const file of files) {
    if (!file) continue;
    const key = FirebaseWorker.ref('/').push().key;
    const storageRef = firebase.storage().ref(`bug_feedback_files/uploads/${key}`);
    await storageRef.put(file);
    const url = await storageRef.getDownloadURL();
    uploaded.push({ name: file.name, url });
  }
  return uploaded;
}

export function buildBugFeedbackBody({
  description,
  reporterName,
  reporterEmail,
  pageUrl,
  screenshots = [],
  bugRecreation,
  bugExpected,
  includeInternalFields,
  details = {}
}) {
  let body = `What went wrong:\n${description}\n\nSubmitted by: ${reporterName}\n(${reporterEmail})\n\nLink to buggy page: ${pageUrl}`;

  const attachedScreenshots = screenshots.filter((screenshot) => screenshot?.url);
  if (attachedScreenshots.length) {
    body += '\n\nScreenshots:';
    for (const screenshot of attachedScreenshots) {
      body += `\n${screenshot.name ? `${screenshot.name}: ` : ''}${screenshot.url}`;
    }
  }

  if (bugRecreation) body += `\n\nHow to Recreate It:\n${bugRecreation}`;

  if (includeInternalFields) {
    if (bugExpected) body += `\n\nWhat it should do:\n${bugExpected}`;
  }

  for (const [key, value] of Object.entries(details)) {
    if (value == null || value === '') continue;
    body += `\n${key}: ${value}`;
  }

  return body;
}

export function sendBugFeedbackRequest({ FirebaseWorker, addresses, subject, body }) {
  return new Promise((resolve) => {
    const requestKey = FirebaseWorker.ref('/photoheight/server_requests/email/requests').push({
      addresses,
      subject: subject || 'Software Bug Feedback',
      body,
      group_tag: 'internal'
    }).key;

    const responseRef = FirebaseWorker.ref(`/photoheight/server_requests/email/responses/${requestKey}`);
    const handleResponse = (snapshot) => {
      const response = snapshot.val();
      if (!response) return;

      responseRef.off('value', handleResponse);
      resolve(response);
      snapshot.ref.remove();
    };
    responseRef.on('value', handleResponse);
  });
}
